"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWebinars = fetchWebinars;
exports.fetchWebinarsSettings = fetchWebinarsSettings;
exports.FAIL_GETTING_WEBINAR_SETTINGS = exports.SUCCEED_GETTING_WEBINAR_SETTINGS = exports.RECEIVE_WEBINAR_SETTINGS = exports.REQUEST_WEBINAR_SETTINGS = exports.FAIL_GETTING_WEBINARS = exports.SUCCEED_GETTING_WEBINARS = exports.RECEIVE_WEBINARS = exports.REQUEST_WEBINARS = void 0;

var _GoToWebinars = require("lead-flows-ui/api/GoToWebinars");

function createAction(name) {
  return "@@goToWebinars/" + name;
}

var REQUEST_WEBINARS = createAction('REQUEST_WEBINARS');
exports.REQUEST_WEBINARS = REQUEST_WEBINARS;
var RECEIVE_WEBINARS = createAction('RECEIVE_WEBINARS');
exports.RECEIVE_WEBINARS = RECEIVE_WEBINARS;
var SUCCEED_GETTING_WEBINARS = createAction('SUCCEED_GETTING_WEBINARS');
exports.SUCCEED_GETTING_WEBINARS = SUCCEED_GETTING_WEBINARS;
var FAIL_GETTING_WEBINARS = createAction('FAIL_GETTING_WEBINARS');
exports.FAIL_GETTING_WEBINARS = FAIL_GETTING_WEBINARS;
var REQUEST_WEBINAR_SETTINGS = createAction('REQUEST_WEBINAR_SETTINGS');
exports.REQUEST_WEBINAR_SETTINGS = REQUEST_WEBINAR_SETTINGS;
var RECEIVE_WEBINAR_SETTINGS = createAction('RECEIVE_WEBINAR_SETTINGS');
exports.RECEIVE_WEBINAR_SETTINGS = RECEIVE_WEBINAR_SETTINGS;
var SUCCEED_GETTING_WEBINAR_SETTINGS = createAction('SUCCEED_GETTING_WEBINAR_SETTINGS');
exports.SUCCEED_GETTING_WEBINAR_SETTINGS = SUCCEED_GETTING_WEBINAR_SETTINGS;
var FAIL_GETTING_WEBINAR_SETTINGS = createAction('FAIL_GETTING_WEBINAR_SETTINGS'); // Action creators

exports.FAIL_GETTING_WEBINAR_SETTINGS = FAIL_GETTING_WEBINAR_SETTINGS;

function requestWebinars() {
  return {
    type: REQUEST_WEBINARS
  };
}

function receiveWebinars(webinars) {
  return {
    type: RECEIVE_WEBINARS,
    webinars: webinars
  };
}

function succeedGettingWebinars() {
  return {
    type: SUCCEED_GETTING_WEBINARS
  };
}

function failGettingWebinars() {
  return {
    type: FAIL_GETTING_WEBINARS
  };
}

function requestWebinarsSettings() {
  return {
    type: REQUEST_WEBINAR_SETTINGS
  };
}

function receiveWebinarsSettings(settings) {
  return {
    type: RECEIVE_WEBINAR_SETTINGS,
    settings: settings
  };
}

function succeedGettingWebinarsSettings() {
  return {
    type: SUCCEED_GETTING_WEBINAR_SETTINGS
  };
}

function failGettingWebinarscSettings() {
  return {
    type: FAIL_GETTING_WEBINAR_SETTINGS
  };
}

function fetchWebinars() {
  return function (dispatch) {
    dispatch(requestWebinars());
    return (0, _GoToWebinars.getWebinars)().then(function (response) {
      dispatch(succeedGettingWebinars());
      dispatch(receiveWebinars(response));
    }, function (error) {
      dispatch(failGettingWebinars(error.xhr));
    }).done();
  };
}

function fetchWebinarsSettings() {
  return function (dispatch) {
    dispatch(requestWebinarsSettings());
    return (0, _GoToWebinars.getWebinarsSettings)().then(function (response) {
      dispatch(succeedGettingWebinarsSettings());

      if (response.enabled) {
        dispatch(fetchWebinars());
      }

      dispatch(receiveWebinarsSettings(response));
    }, function (error) {
      dispatch(failGettingWebinarscSettings(error.xhr));
    }).done();
  };
}